/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	HttpClient
} from '@angular/common/http';
import {
	Inject,
	Injectable
} from '@angular/core';
import {
	ISecurityApplicationDto
} from '@api/interfaces/security/security-application.dto.interface';
import {
	BaseEntityApiService
} from '@api/services/base/base-entity.api.service';
import {
	AppConstants
} from '@shared/constants/app.constants';
import {
	CacheService
} from '@shared/services/cache.service';

/**
 * A class representing the logic and services of the security
 * application controller.
 *
 * @export
 * @class SecurityApplicationApiService
 * @extends {BaseEntityApiService<ISecurityApplicationDto>}
 */
@Injectable()
export class SecurityApplicationApiService
	extends BaseEntityApiService<ISecurityApplicationDto>
{
	/**
	 * Creates an instance of a SecurityApplicationApiService.
	 *
	 * @param {HttpClient} HttpClient
	 * The injected http client to use in the base api service.
	 * @param {CacheService} cache
	 * The injected cache service to use in the base api service.
	 * @memberof SecurityApplicationApiService
	 */
	public constructor(
		@Inject(HttpClient) http: HttpClient,
		@Inject(CacheService) cache: CacheService)
	{
		super();
		this.httpClient = http;
		this.cacheService = cache;
		this.endpoint =
			AppConstants.apiControllers.securityApplications;
	}
}